"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
function NextButton(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement(material_1.Button, Object.assign({ endIcon: react_1.default.createElement(icons_material_1.ArrowRight, null) }, props, { size: props.size || "medium", variant: props.variant || "contained", color: props.color || "primary" }), props.text || t("common.seuraava")));
}
exports.default = NextButton;
